import React, { Component } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown} from "@fortawesome/free-solid-svg-icons";
import { withTranslation } from 'react-i18next';

class SelectWithSearchComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: this._getInitialOptions(),
            filteredOptions: [],
            selectedOption: this.props.selected,
            searchText: this.props.selected ? this._getNameOfAdAccount(this.props.options, this.props.selected) : "",
            showDropdown: false,
            showFormValidationTexts: this.props.showFormValidationTexts
        };

        this.dropdownRef = null;
    }

    _addBlankOptionIfNeeded(options) {
        const { t } = this.props;
        if(this.props.blackSelection === true && !options.some(opt => opt.id === -1)) {
            options.unshift({id: -1, text: t('select_with_search.blank_option'), className:"blank-item"});
        }
        return options;
    }

    _getInitialOptions() {
        const options = [...(this.props.options || [])];
        return this._addBlankOptionIfNeeded(options);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.optionsVersion !== this.props.optionsVersion ||
            prevProps.selected !== this.props.selected ||
            prevProps.showFormValidationTexts !== this.props.showFormValidationTexts ||
            prevProps.options !== this.props.options ||
            prevProps.blackSelection !== this.props.blackSelection) {

            let selectedOption = null;
            let searchText = this.state.searchText;

            const nextOptions = [...(this.props.options || [])];
            const optionsWithBlank = this._addBlankOptionIfNeeded(nextOptions);

            if (prevProps.selected !== this.props.selected || prevProps.options !== this.props.options) {
                selectedOption = this.props.selected;
                const option = Array.isArray(optionsWithBlank) ? optionsWithBlank.find(obj => obj.id === this.props.selected) : null;
                searchText = option !== undefined && option !== null ? option.text : "";
            }

            this.setState({
                options: optionsWithBlank,
                filteredOptions: optionsWithBlank,
                selectedOption: selectedOption,
                searchText: searchText,
                showFormValidationTexts: this.props.showFormValidationTexts
            })
        }
    }

    componentDidMount() {
        // Initially set the filteredOptions to all options
        const { options } = this.state;
        const filteredOptions = options === null || options === undefined ? [] : options;
        this.setState({ filteredOptions: filteredOptions });

        // Add click event listener to the document body
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        // Remove the event listener when the component unmounts
        document.removeEventListener('click', this.handleClickOutside);
    }

    _getNameOfAdAccount(options, selectedId) {
        if (!Array.isArray(options)) {
            return ""
        }

        const foundItem = options.find(item => item.id === selectedId);
        return foundItem ? foundItem.text : null;
    }

    handleClickOutside = (event) => {
        if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
            // Click occurred outside the dropdown, hide it
            this.setState({ showDropdown: false });
        }
    };

    handleInputChange = (event) => {
        const { options } = this.state;

        if(options === null || options === undefined)
            return;

        const searchQuery = event.target.value.toLowerCase();

        const filteredOptions = options.filter(option =>
            option.text.toLowerCase().includes(searchQuery)
        );

        this.setState({
            filteredOptions: filteredOptions,
            selectedOption: null,
            showDropdown: true,
            searchText: event.target.value
        });
    };

    getNotSelectableOptions(){
        return this.props.optionosNotSelectable ? this.props.optionosNotSelectable : [];
    }

    handleSelectOption = (option) => {
        if(option.id === -1){
            this.setState({
                selectedOption: null,
                showDropdown: false,
                searchText: ""
            });
            this.props.onSelectOptionChange({id:null, text: null})
            return;
        }

        if(!this.getNotSelectableOptions().includes(option.id)) {
            this.setState({
                selectedOption: option,
                showDropdown: false,
                searchText: option.text
            });
        }

        this.props.onSelectOptionChange(option)
    };

    render() {
        const { t } = this.props;
        const { selectedOption, filteredOptions, showDropdown } = this.state;
        const showError = this.props.showFormValidationTexts && selectedOption === null;

        return (
                <div className="dropdown select-with-search" ref={(ref) => (this.dropdownRef = ref)}>
                    <div>
                        <input
                            type="text"
                            value={this.state.searchText}
                            className="form-control dropdown-toggle"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            placeholder={t('select_with_search.placeholder')}
                            autoComplete="off" // Add this attribute to disable autofill
                            onChange={this.handleInputChange}
                            onClick={() => this.setState({ showDropdown: true })}
                            style={{ paddingRight: '2.5em' }} // Adjust padding for the icon
                        />
                        <div onClick={() => this.setState({ showDropdown: true })}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                right: '8px', // Adjust the distance from the input's right side
                            }}
                        >
                            <FontAwesomeIcon icon={faChevronDown} style={{ color: "#495057", fontSize:"0.70em", cursor: 'pointer' }} />
                        </div>
                    </div>
                    {showError && <p style={{ color: 'red' }}>{this.props.errorText !== undefined ? this.props.errorText : "Debe seleccionar una cuenta publicitaria."}</p>}
                    {showDropdown && (
                        <div className="dropdown-menu show" aria-labelledby="dropdownMenuButton" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                            {filteredOptions.length > 0 ? (
                                filteredOptions.map(option => (
                                    <button
                                        key={option.id}
                                        className={"dropdown-item " + option.className}
                                        type="button"
                                        onClick={() => this.handleSelectOption(option)}
                                    >
                                        {option.text}
                                    </button>
                                ))
                            ) : (
                                <span className="dropdown-item">No se han encontrado items.</span>
                            )}
                        </div>
                    )}
                </div>
        );
    }
}

export const SelectWithSearch = withTranslation()(SelectWithSearchComponent);
